<template>
    <div class="modal fade text-left" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    <h4 class="modal-title text-white" id="myModalLabel17">{{ afterAccount.furnisher_name }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-danger table-striped table-hover mb-0">
                            <tbody class="table-striped">
                                <tr>
                                    <td style="width:100px">
                                        Dispute Data
                                    </td>
                                    <td style="width:100px">
                                        Before
                                    </td>
                                    <td style="width:100px">
                                        After
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Number:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.account_number }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.account_number }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Status:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.account_status }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.account_status }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Type:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.account_type }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.account_type }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Detail:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.account_detail }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.account_detail }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Bureau Code:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.bureau_code }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.bureau_code }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Monthly Payment:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.monthly_payment }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.monthly_payment }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Payment Status:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.payment_status }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.payment_status }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Past Due:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.past_due }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.past_due }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Date Opened:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(beforeAccount.date_opened) }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(afterAccount.date_opened) }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Date Last Active:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(beforeAccount.date_last_active) }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(afterAccount.date_last_active) }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Date Last Payment:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(beforeAccount.date_last_payment) }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(afterAccount.date_last_payment) }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>High Credit:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.high_credit }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.high_credit }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Last Reported:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(beforeAccount.last_reported) }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.formatDate(afterAccount.last_reported) }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Month Term:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.number_of_months }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.number_of_months }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Comments:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ beforeAccount.comments }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ afterAccount.comments }}
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useReportStore } from '../../../stores/ReportStore.js'
    export default {
        mounted() {
        },
        props: {
            beforeAccount: {
                type: [Array, Object]
            },
            afterAccount: {
                type: [Array, Object]
            },
            id: String,
            email: String
        },
        setup() {
            return {
                reportStore: useReportStore()
            }
        },
    }
</script>
